import React from 'react';
import { Grid, Card, Typography } from '@material-ui/core';
import { useGlobal } from '@rcg/ui-react';
import { countdownClockStyles } from './index.style';
import useCountdown from '../../hooks/useCountdown';

const TimeUnit = ({ amount, label, dataTestId, isCourtesyHold }) => {
  return (
    <Grid item className="timeUnit">
      <Typography
        className={`timeUnit__amount ${isCourtesyHold && 'courtesyHoldAmount'}`}
        component="span"
        data-testid={dataTestId}
        id={dataTestId}
        variant="inherit">
        {amount}
      </Typography>
      <Typography
        component="span"
        className={`timeUnit__label ${isCourtesyHold ? 'courtesyHoldAmount' : ''} 
  }`}
        variant="inherit">
        {label}
      </Typography>
    </Grid>
  );
};

const CountdownClock = (props) => {
  const { endDate, elevation, title, className, isCourtesyHold } = props;
  const [days, hours, minutes, seconds] = useCountdown(new Date(endDate));
  const { renderContent } = useGlobal();
  const classes = countdownClockStyles(props);

  if (isCourtesyHold && seconds < 0) {
    return <></>;
  }

  return (
    <Card
      className={`${classes.root} ${isCourtesyHold ? classes.courtesyHold : ''}`}
      elevation={elevation || 0}>
      <Grid container className={`countDownContainer ${className}`}>
        <Grid item sm className="column title">
          <Typography
            component="span"
            className={`timeUnit__label ${isCourtesyHold && 'courtesyHoldView'}`}
            variant="inherit">
            {title}
          </Typography>
        </Grid>
        <Grid item sm className="column">
          <Grid container className="countDownContainer__values">
            {days > 0 && (
              <TimeUnit
                amount={days}
                label={renderContent('countdownBookingAmendDaysLabel', 'Days')}
                dataTestId="days-left"
                isCourtesyHold={isCourtesyHold}
              />
            )}
            <TimeUnit
              amount={hours}
              label={renderContent('countdownBookingAmendHoursLabel', 'Hrs')}
              dataTestId="hours-left"
              isCourtesyHold={isCourtesyHold}
            />
            <TimeUnit
              amount={minutes}
              label={renderContent('countdownBookingAmendMinutesLabel', 'Min')}
              dataTestId="minutes-left"
              isCourtesyHold={isCourtesyHold}
            />
            {days <= 0 && (
              <TimeUnit
                amount={seconds}
                label={renderContent('countdownBookingAmendSecondsLabel', 'Sec')}
                dataTestId="seconds-left"
                isCourtesyHold={isCourtesyHold}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CountdownClock;
